<template>
  <div
    v-if="text"
    class="ErrorComp a-cover z-100 overflow-hidden flex-c bg-white text-black"
  >
    <h1
      class="text-3xl font-body-bold text-center"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
  name: 'ErrorComp',

  components: {
  },

  props: {
    text: {
      type: String,
      default: ''
    },
  },
}
</script>

